import type { DividerDefaultProps } from './DividerDefault.types';
import { getClassNames } from './DividerDefault.utils';

export const DividerDefault = (props: DividerDefaultProps) => {
  const classNames = getClassNames(props);

  return <div className={classNames} />;
};
